import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserEditDto } from '../../../../dto/userEditDto';

@Component({
  selector: 'app-delete-user-dialog-content',
  templateUrl: './delete-user-dialog-content.component.html',
  styleUrls: ['./delete-user-dialog-content.component.scss']
})
export class DeleteUserDialogContentComponent extends AbstractDialogContent implements OnInit {

  spinner1 = 'editSpinner';
  public className = 'DeleteUserDialogContentComponent';

  @Input() private userId: string;
  @Input() private user: UserEditDto;


  constructor(
    public activeModal: NgbActiveModal,
    private usersService: UsersService,
    private spinner: NgxSpinnerService,
    private toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onConfirmClick() {
    this.spinner.show(this.spinner1);
    const userAction = this.isUserDummy() ? this.usersService.deleteEntity(this.userId) : this.usersService.DisinviteUser(this.userId);

    userAction.subscribe(result => {
        this.spinner.hide(this.spinner1);
        this.activeModal.close({ success: true });
    }, error => {
        this.toastService.error($localize`:@@DeletedDialogErrorHeader:Benutzer konnte nicht gelöscht werden.`);
        this.spinner.hide(this.spinner1);
        this.activeModal.close({ success: false, error: error });
    });
}


  getDeleteText(): string {
    let nonDummy = "Durch das Entfernen wird der Benutzer von Ihrem Ladepark getrennt. Er hat dadurch keine Zugriffe mehr auf Ihre Ladestationen. Sein Account bleibt aber weiterhin bestehen, damit der Benutzer Einsicht auf seine Ladevorgänge, Lieferscheine oder Rechnungen hat."
    let dummy = "";
    return this.isUserDummy() ? dummy : nonDummy;
  }

  getDelButtonText(): string {
    return this.isUserDummy() ? 'Benutzer löschen' : 'Benutzer ausladen';
  }

  isUserDummy():boolean{
    return !this.user?.email?.trim();
  }
}
